/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import './styles.scss';
import {
  FaTimes,
} from 'react-icons/fa';
import { Dropdown } from 'bootstrap';
import PropTypes from 'prop-types';
import EpButton from '../EpButton';

let lastAction = 'close';
let modalStickInstance = null;

export const handleToggleModalStick = (buttonToggleId) => {
  const triggerEl = document.getElementById(buttonToggleId);
  modalStickInstance = Dropdown.getOrCreateInstance(triggerEl);

  if (lastAction === 'close') {
    lastAction = 'open';
    modalStickInstance.show();
  } else if (lastAction === 'open') {
    lastAction = 'close';
    modalStickInstance.hide();
  }
};

const EpModalStick = ({
  headerTitle, headerContent, bodyContent, footerContent, size, modalStickId, buttonToggleId,
}) => (
  <div className="modal-sticky">
    <div className={`modal-content modal-stick__content ${size}`} id={modalStickId}>
      <div className="modal-header modal-stick__content-header">
        <h5 className="modal-title modal-stick__content-header-title">{headerTitle}</h5>
        <div className="modal-stick__content-header-buttons">
          {headerContent}

          <EpButton
            buttonIcon={<FaTimes className="btn__icon" />}
            buttonType="link-secondary"
            customClass="modal-stick__content-header-close"
            actionType="button"
            buttonId="button__dropdown-columns"
            ariaExpanded="false"
            autoClose="false"
            aria-label="Close"
            linkFunc={() => handleToggleModalStick(buttonToggleId)}
            size="sm"
          />
        </div>
      </div>

      <div className="modal-body modal-stick__content-body">
        {bodyContent}
      </div>

      {footerContent
      && (
        <div className="modal-footer modal-stick__content-footer">
          {footerContent}
        </div>
      )}
    </div>
  </div>
);

export default EpModalStick;

EpModalStick.defaultProps = {
  headerContent: null,
  footerContent: null,
  buttonToggleId: null,
  size: 'md',
};

EpModalStick.propTypes = {
  footerContent: PropTypes.element,
  headerContent: PropTypes.element,
  headerTitle: PropTypes.string.isRequired,
  bodyContent: PropTypes.element.isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
  modalStickId: PropTypes.string.isRequired,
  buttonToggleId: PropTypes.string,
};
